import { useMemo } from 'react';
import { useScope } from '@workspace/scope-context';

import { useSession } from '@/context/SessionContext';

export function useTenantIdentityProvidersAccess() {
  const { activeTenant } = useScope();
  const { session } = useSession();
  return useMemo(() => {
    const tenantId = activeTenant?.id ?? '';
    const tenantPermissions = tenantId ? session?.permissionSummary?.tenants?.[tenantId] ?? [] : [];
    const globalPermissions = session?.permissionSummary?.global ?? [];
    const platformManage = globalPermissions.includes('platform.manage');
    return {
      tenantId,
      tenantLabel: activeTenant?.name ?? activeTenant?.id ?? 'No tenant selected',
      canView: Boolean(tenantId) && (tenantPermissions.includes('tenant.identity-providers.view') || tenantPermissions.includes('tenant.identity-providers.manage') || platformManage),
      canManage: Boolean(tenantId) && (tenantPermissions.includes('tenant.identity-providers.manage') || platformManage),
      canManageRoleMappings: Boolean(tenantId) && ((tenantPermissions.includes('tenant.identity-providers.manage') && tenantPermissions.includes('tenant.members.manage')) || platformManage),
    };
  }, [activeTenant?.id, activeTenant?.name, session?.permissionSummary]);
}
